// extracted by mini-css-extract-plugin
module.exports = {"active":"style_active__2pVEv","inactive":"style_inactive__iJR6a","closeModalButton":"style_closeModalButton__3W2__"};